import { CountryEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { AddressFields, Section } from 'modules/client/common/components';

interface Props {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const RegistrationAddressSection = ({
  countriesLoading,
  countries,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="registrationAddressSection"
      title={t('client.client.registrationAddress.title')}
    >
      <AddressFields
        countries={countries}
        countriesLoading={countriesLoading}
        variant="registrationAddress"
      />
    </Section>
  );
};
